import React from "react";
import ContentLoader from "react-content-loader";

const AboutPlaceholder = () => {
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <ContentLoader viewBox="0 0 500 150" className="mb-3">
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="150" />
      </ContentLoader>
    </div>
  );
};

export default AboutPlaceholder;
